module.exports = __webpack_public_path__ + "static/media/grid-2.8d0287e8.jpg";